import rest from "../axiosRestCalls";
import store from "../../core/redux/Store";
import {setMakes, setModels, setSizes, setTrims, setYears} from "../../core/redux/ActionCreator";
import {API_BASE_PATH, API_TIRE_SIZE_PATH} from "../restConstants";

const API = API_BASE_PATH + API_TIRE_SIZE_PATH;
class yearMakeModelService{
    getYears(){
        rest.get(API + 'year').then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setYears(res.data));
            }
        });
    }

    getMakes(year){
        if(year === ''){
            year = null;
        }
       let url = API + year + '/make';
       rest.get(url).then((res) => {
           if (Object.keys(res.data).length > 0) {
               store.dispatch(setMakes(res.data));
           }
       });
    }

    getModels(year, make){
        if(year === ''){
            year = null;
        }
        if (make === ''){
            make = null;
        }

        let url = API + year + '/' + make + '/model';
        rest.get(url).then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setModels(res.data));
            }
        });
    }

    getTrims(year, make, model){
        if(year === ''){
            year = null;
        }
        if (make === ''){
            make = null;
        }
        if (model === ''){
            model = null;
        }

        let url = API + year + '/' + make + '/' + model.replaceAll('/','_') + '/trim';
        rest.get(url).then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setTrims(res.data));
            }
        });
    }

    getSizes(year, make, model, trim){
        if(year === ''){
            year = null;
        }
        if (make === ''){
            make = null;
        }
        if (model === ''){
            model = null;
        }
        if (trim === ''){
            trim = null;
        }else if (trim !== null){
            trim = trim.replaceAll('/','_');
        }

        let url = API + year + '/' + make + '/' + model.replaceAll('/','_') + '/' + trim + '/tireSize';
        rest.get(url).then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setSizes(res.data));
            }
        });
    }
}
// eslint-disable-next-line
export default new yearMakeModelService();
